import { Link, styled, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const FormWrapperMainAgreement = styled(Typography)({
  color: palette.text.body,
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
}) as typeof Typography;

export const FormWrapperMainLink = styled(Link)({
  color: palette.primary.purple500,
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '18px',
  cursor: 'pointer',
  textDecoration: 'none',
}) as typeof Link;
